module.exports = globalThis.gameanalytics;